<script>
export default {
  props: {
    module: Object,
  },
  methods: {
    close() {
      this.module.show = false;
    },
  },
};
</script>
<template>
  <div class="mag-template-feature" v-if="module.show">
    <v-main>
      <div class="mag-template-feature__wrap">
        <div class="mag-template-feature__content">
          <v-card
            width="420"
          >
            <v-card-title>Платная услуга</v-card-title>
            <v-list-item>
              <v-list-item-avatar color="warning">
                <v-icon color="#fff">mdi-alert-circle</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                Работа с данным модулем недоступна для Вашего тарифного плана.<br>
                Перейти управлению тарифами?
              </v-list-item-content>
            </v-list-item>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                text
                @click="close"
              >
                Закрыть
              </v-btn>
              <v-btn
                color="primary"
                href="/tourclient/dictionary/#/admin/features"
              >
                Перейти
              </v-btn>
            </v-card-actions>
          </v-card>
        </div>
      </div>
    </v-main>
  </div>
</template>
<style lang="scss">
  .mag-template-feature {
    position: fixed;
    width: 100%;
    height: 100%;

    &__wrap {
      height: calc(100vh - 64px);
      background: rgba(0, 0, 0, .7);
    }

    &__content {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
</style>
